import { Content } from "../Content/Content"
import { Alert, Box, Button, Snackbar, Stack, Typography } from "@mui/material";

function DK() {

  const headers = [
    { text: "STT" },
    { text: "Họ tên" },
    { text: "Pháp danh" },
    { text: "Tu tại chùa" },
    { text: "Tu tại nhóm" },
    { text: "Tu nhà riêng" },
    { text: "Lý do riêng xin nghe Pháp lại sau" },
    { text: "Nghỉ không báo (chỉ dành cho BQC điền, PT không tự điền)" },
    { text: "GHI CHÚ" },
  ];
  const groups = [
    {
      name: "PHẬT TỬ DỰ THÍNH",
      members: [{ name: "Đỗ Văn Đạt", PD: "Đạt Quảng Nghiêm", DK: ["Tu nhà riêng"] },
      { name: "Hoàng Thị Thủy", PD: "Thủy Hương Hạnh", DK: ["Lý do riêng xin nghe Pháp lại sau"] }
      ],
    },
    {
      name: "PHẬT TỬ TÙY HỶ",
      members: [{ name: "Nguyễn Thị Ánh", PD: "Ánh Thanh Hiếu", DK: ["Lý do riêng xin nghe Pháp lại sau"] }
      ],
    }
  ];
  const title = (
    <Stack spacing={2} direction="row">

      <Button
        variant="contained"
      >
        Undo
      </Button>

      <Button
        variant="contained"
      >
        Redo
      </Button>
    </Stack>
  );
  const footer = (
    <Stack spacing={2} direction="row">

      <Button
        variant="contained"
      >
        Menu
      </Button>

      <Button
        variant="contained"
      >
        Sheet1
      </Button>
    </Stack>
  );
  return <Content
    title={title}
    footer={footer}
  >

  </Content>;
}


export default DK;